export const DELETE_IMAGES='DELETE_IMAGES';
export const FETCH_ALL_IMAGES='FETCH_ALL_IMAGES';
export const CREATE_IMAGES='CREATE_IMAGES';
export const START_LOADING_IMAGES='START_LOADING_IMAGES';
export const END_LOADING_IMAGES='END_LOADING_IMAGES';
